// assets/main-conjunto.js
// (mesmo arquivo, mesma lógica — só adicionada a “liberação” do origin-tracking
//  no clique do botão do conjunto, antes de qualquer update/add)

(function () {
  const conjuntoSection = document.querySelector('.conjunto-page');
  if (!conjuntoSection) {
    console.error('CONJUNTO: seção .conjunto-page não encontrada');
    return;
  }

  const sectionIdMatch = conjuntoSection.id.match(/^Conjunto-(.+)$/);
  const sectionId = sectionIdMatch ? sectionIdMatch[1] : '';

  const conjuntoMetaEl = document.getElementById(`ConjuntoMeta-${sectionId}`);
  let conjuntoMeta = {
    discount: 0,
    installments: 1,
    installment_suffix: '',
    cashback_enabled: false,
    cashback_percentage: 0,
    cashback_prefix: '',
    cashback_suffix: '',
    coupon_name: ''
  };

  if (conjuntoMetaEl) {
    try {
      conjuntoMeta = JSON.parse(conjuntoMetaEl.textContent.trim());
    } catch (e) {
      console.warn('Erro ao parsear ConjuntoMeta JSON', e);
    }
  }

  const couponName =
    conjuntoSection.dataset.conjuntoCoupon ||
    conjuntoMeta.coupon_name ||
    '';

  const stepsContainer = conjuntoSection.querySelector('[data-conjunto-steps]');
  if (!stepsContainer) {
    console.error('CONJUNTO: data-conjunto-steps não encontrado');
    return;
  }

  const stepElements = Array.from(stepsContainer.querySelectorAll('.conjunto-step'));
  const totalStepsAttr = parseInt(stepsContainer.dataset.conjuntoStepsCount || '0', 10);
  const totalSteps = totalStepsAttr || stepElements.length;
  if (!totalSteps) {
    console.error('CONJUNTO: totalSteps inválido', {
      totalStepsAttr,
      stepElementsCount: stepElements.length
    });
    return;
  }

  const currentStepLabel = stepsContainer.querySelector('[data-conjunto-current-step]');
  const btnPrev = stepsContainer.querySelector('[data-conjunto-prev]');
  const btnNext = stepsContainer.querySelector('[data-conjunto-next]');
  const btnSubmit = conjuntoSection.querySelector('[data-conjunto-submit]');

  const totalOriginalEl = conjuntoSection.querySelector('[data-conjunto-total-original]');
  const totalDiscountedEl = conjuntoSection.querySelector('[data-conjunto-total-discounted]');
  const installmentEl = conjuntoSection.querySelector('[data-conjunto-installment]');
  const cashbackEl = conjuntoSection.querySelector('[data-conjunto-cashback]');

  const galleryTrack = conjuntoSection.querySelector('[data-conjunto-gallery]');
  const galleryItems = galleryTrack ? Array.from(galleryTrack.querySelectorAll('.conjunto-gallery__item')) : [];
  const galleryPrev = conjuntoSection.querySelector('.conjunto-gallery__arrow--prev');
  const galleryNext = conjuntoSection.querySelector('.conjunto-gallery__arrow--next');
  const galleryModal = conjuntoSection.querySelector('.conjunto-gallery-modal');
  const galleryModalImg = conjuntoSection.querySelector('.conjunto-gallery-modal__img');
  const galleryModalClose = conjuntoSection.querySelector('.conjunto-gallery-modal__close');
  const galleryModalBackdrop = conjuntoSection.querySelector('.conjunto-gallery-modal__backdrop');

  const stepJsonScripts = Array.from(document.querySelectorAll('script[data-conjunto-step-json]'));
  const stepVariantsMap = {};

  stepJsonScripts.forEach((script) => {
    const idx = parseInt(script.dataset.conjuntoStepIndex || '0', 10);
    try {
      stepVariantsMap[idx] = JSON.parse(script.textContent.trim());
    } catch (e) {
      console.warn('Erro ao parsear variants do passo', idx, e);
      stepVariantsMap[idx] = [];
    }
  });

  // ======================================================
  // ORIGIN TRACKING "LIBERAÇÃO" — MESMO PADRÃO DO main-kit.js
  // - markAtc(tag)
  // - flush()
  // - micro-yield ANTES de qualquer /cart/update.js e /cart/add.js
  // - sem alterar a lógica do conjunto
  // ======================================================
  async function originReleaseBeforeCartOps(btnEl) {
    try {
      const tag =
        (btnEl && btnEl.getAttribute('data-origem-atc')) ||
        'add_cart__pdp_conjunto__botao_principal';

      // 1) markAtc
      if (window.IALLY_ORIGIN && typeof window.IALLY_ORIGIN.markAtc === 'function') {
        window.IALLY_ORIGIN.markAtc(tag);
      }

      // 2) flush (aguarda se retornar Promise)
      if (window.IALLY_ORIGIN && typeof window.IALLY_ORIGIN.flush === 'function') {
        const maybePromise = window.IALLY_ORIGIN.flush();
        if (maybePromise && typeof maybePromise.then === 'function') {
          try { await maybePromise; } catch (_) { }
        }
      }

      // 3) micro-yield: prioriza o request do tracking antes do update/add
      await new Promise((r) => setTimeout(r, 30));
    } catch (_) { }
  }

  // Normaliza strings (remove acentos, espaços, etc)
  const norm = (s) => (s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\w]+/g, '-');

  // Verifica se um item de galeria pertence à cor (por segmento do handle)
  function itemMatchesColor(item, colorKey) {
    if (!colorKey) return true;
    const handle = norm(item.dataset.colorHandle || '');
    if (!handle) return false;
    const parts = handle.split('-');
    return parts.includes(colorKey);
  }

  const stepsState = stepElements.map((stepEl, idx) => {
    const variants = stepVariantsMap[idx] || [];
    const variantInput = stepEl.querySelector('[data-conjunto-variant-id]');
    let initialVariantId = variantInput ? parseInt(variantInput.value, 10) : null;
    let initialVariant = variants.find((v) => v.id === initialVariantId) || variants[0];

    let color = '';
    let size = '';

    const checkedColor = stepEl.querySelector('.conjunto-option__input--color:checked');
    if (checkedColor) color = checkedColor.value;

    const checkedSize = stepEl.querySelector('.conjunto-option__input--size:checked');
    if (checkedSize) size = checkedSize.value;

    if (!initialVariant && variants.length) {
      initialVariant = variants[0];
      initialVariantId = initialVariant.id;
      if (!color && initialVariant.option1) color = initialVariant.option1;
      if (!size && initialVariant.option2) size = initialVariant.option2;
      if (variantInput) variantInput.value = initialVariant.id;
    }

    const state = {
      stepIndex: idx,
      variants,
      selectedVariant: initialVariant || null,
      color,
      size
    };
    return state;
  });

  let currentStep = 0;
  let currentGalleryIndex = 0;

  function formatMoneySafe(cents) {
    try {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
    } catch (_) { }
    try {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format((cents || 0) / 100);
    } catch (_) {
      return String((cents || 0) / 100);
    }
  }

function getVariantForSelection(stepIdx, colorValue, sizeValue) {
  const state = stepsState[stepIdx];
  if (!state || !state.variants.length) return null;

  // ✅ Se esse produto NÃO tem tamanho (option2 null em todas as variantes), ignora size
  const hasSize = state.variants.some(v => v.option2 != null && v.option2 !== '');

  return (
    state.variants.find((v) => {
      const matchColor = colorValue ? v.option1 === colorValue : true;

      // ✅ Se não tem size, não filtra por size
      const matchSize = !hasSize ? true : (sizeValue ? v.option2 === sizeValue : true);

      const hasStock = v.available === undefined ? true : !!v.available;
      return matchColor && matchSize && hasStock;
    }) || null
  );
}


  // ===== MELHORIA: atualiza classe do wizard e do step quando item vira brinde (0) =====
function updateGiftUiForStep(stepEl, compareCents, finalCents) {
  if (!stepEl) return;

  const isGift = (finalCents === 0 && compareCents > 0);

  stepEl.classList.toggle('conjunto-step--gift', isGift);

  const giftNote = stepEl.querySelector('[data-conjunto-gift-note]');
  if (giftNote) giftNote.hidden = !isGift;

  try {
    const anyGift = stepElements.some((el) => el.classList.contains('conjunto-step--gift'));
    stepsContainer.classList.toggle('conjunto-steps--has-gift', anyGift);
  } catch (_) {}
}


function recalcTotals() {
  let totalOriginal = 0;
  let totalDiscounted = 0;

stepsState.forEach((state) => {
  const stepEl = stepElements[state.stepIndex];
  if (!stepEl) return;

  // ✅ Resolve a variante SEMPRE pelo DOM (evita state “travado”)
  const checkedColor = stepEl.querySelector('.conjunto-option__input--color:checked');
  const checkedSize  = stepEl.querySelector('.conjunto-option__input--size:checked');

  const colorValue = checkedColor ? checkedColor.value : (state.color || '');
  const sizeValue  = checkedSize  ? checkedSize.value  : (state.size  || '');

  const variant =
    getVariantForSelection(state.stepIndex, colorValue, sizeValue) ||
    state.selectedVariant ||
    null;

  state.color = colorValue;
  state.size  = sizeValue;
  state.selectedVariant = variant;

  if (!variant) return;

  // ✅ BASE REAL: preço atual do variant (brinde = 0)
  const baseCents = Number(variant.price || 0);

  // ✅ COMPARE: se compare_at for maior, usa ele; senão usa base
  const compareCentsRaw = Number(variant.compare_at_price || 0);
  const compareCents = compareCentsRaw > baseCents ? compareCentsRaw : baseCents;

  // ✅ FINAL: desconto do conjunto em cima do base
  const finalCents =
    conjuntoMeta.discount && conjuntoMeta.discount > 0
      ? Math.max(0, baseCents - Math.round((baseCents * conjuntoMeta.discount) / 100))
      : baseCents;

  totalOriginal += compareCents;
  totalDiscounted += finalCents;

  const unitOriginalEl = stepEl.querySelector('[data-conjunto-unit-original]');
  const unitDiscountedEl = stepEl.querySelector('[data-conjunto-unit-discounted]');

  if (unitOriginalEl) unitOriginalEl.textContent = formatMoneySafe(compareCents);
  if (unitDiscountedEl) unitDiscountedEl.textContent = formatMoneySafe(finalCents);

  if (unitOriginalEl) {
    const isGift = (finalCents === 0 && compareCents > 0);
    if (compareCents > finalCents || isGift) {
      unitOriginalEl.style.display = '';
      try { unitOriginalEl.removeAttribute('hidden'); } catch (_) {}
    } else {
      unitOriginalEl.style.display = 'none';
      try { unitOriginalEl.setAttribute('hidden', ''); } catch (_) {}
    }
  }

  updateGiftUiForStep(stepEl, compareCents, finalCents);
});


  if (totalOriginalEl) totalOriginalEl.textContent = formatMoneySafe(totalOriginal);
  if (totalDiscountedEl) totalDiscountedEl.textContent = formatMoneySafe(totalDiscounted);

  if (installmentEl && conjuntoMeta.installments && conjuntoMeta.installments > 0) {
    const installmentValue = Math.round(totalDiscounted / conjuntoMeta.installments);
    installmentEl.textContent =
      `${conjuntoMeta.installments}x de ${formatMoneySafe(installmentValue)} ` +
      (conjuntoMeta.installment_suffix || '');
  }

  // Cashback dinâmico: usa .cashback-banner + .cashback-value
  if (cashbackEl) {
    const banner = cashbackEl.querySelector('.cashback-banner');
    if (!banner) return;

    const pctAttr = banner.dataset.cashbackPercentage;
    const percentage = pctAttr ? Number(pctAttr) : 0;

    if (!percentage || isNaN(percentage)) return;

    const cbAmount = Math.round((totalDiscounted * percentage) / 100);
    const valueEl = cashbackEl.querySelector('.cashback-value');

    if (valueEl) {
      valueEl.textContent = formatMoneySafe(cbAmount);
    }
  }
}


  function itemsForStep(stepIdx) {
    return galleryItems.filter(
      (item) => parseInt(item.dataset.conjuntoStep || '0', 10) === stepIdx
    );
  }

  function filterItemsByColor(stepIdx, items) {
    const state = stepsState[stepIdx];
    const colorKey = norm(state?.color || '');
    if (!colorKey) return items;

    const startIndex = items.findIndex((it) => itemMatchesColor(it, colorKey));
    let seq = [];
    if (startIndex !== -1) {
      for (let i = startIndex; i < items.length; i++) {
        if (!itemMatchesColor(items[i], colorKey)) break;
        seq.push(items[i]);
      }
    }

    const visible = seq.length ? seq : items.filter((it) => itemMatchesColor(it, colorKey));
    return visible.length ? visible : items;
  }

  function setActiveGalleryItem(list, index) {
    galleryItems.forEach((item) => item.classList.remove('is-active'));
    if (!list.length) return;
    const clamped = Math.max(0, Math.min(index, list.length - 1));
    list[clamped].classList.add('is-active');
    currentGalleryIndex = clamped;
    updateGalleryArrows();
  }

  function syncGalleryWithStep() {
    if (!galleryItems.length || !galleryTrack) return;
    const items = itemsForStep(currentStep);
    const filtered = filterItemsByColor(currentStep, items);

    const visibleSet = new Set(filtered);
    galleryItems.forEach((it) => {
      const shouldShow = visibleSet.has(it);
      it.classList.toggle('is-hidden', !shouldShow);
    });

    const activeItem = galleryTrack.querySelector('.conjunto-gallery__item.is-active');
    const keepIndex = activeItem ? filtered.indexOf(activeItem) : -1;
    setActiveGalleryItem(filtered, keepIndex >= 0 ? keepIndex : 0);
  }

  function updateGalleryArrows() {
    if (!galleryItems.length || !galleryTrack) return;
    const items = itemsForStep(currentStep);
    const filtered = filterItemsByColor(currentStep, items);

    if (!filtered.length) {
      if (galleryPrev) galleryPrev.disabled = true;
      if (galleryNext) galleryNext.disabled = true;
      return;
    }
    if (galleryPrev) galleryPrev.disabled = currentGalleryIndex === 0;
    if (galleryNext) galleryNext.disabled = currentGalleryIndex === filtered.length - 1;
  }

  function goGallery(delta) {
    if (!galleryItems.length) return;
    const items = itemsForStep(currentStep);
    const filtered = filterItemsByColor(currentStep, items);
    if (!filtered.length) return;
    const nextIndex = currentGalleryIndex + delta;
    if (nextIndex < 0 || nextIndex >= filtered.length) return;

    const target = filtered[nextIndex];
    try {
      target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    } catch (_) { }
    filtered[currentGalleryIndex]?.classList.remove('is-active');
    currentGalleryIndex = nextIndex;
    filtered[currentGalleryIndex]?.classList.add('is-active');
    updateGalleryArrows();
  }

  function openGalleryModalFromActive() {
    if (!galleryModal || !galleryModalImg || !galleryTrack) return;
    const activeItem = galleryTrack.querySelector('.conjunto-gallery__item.is-active');
    if (!activeItem) return;
    const img = activeItem.querySelector('img');
    if (!img) return;

    galleryModalImg.src = img.currentSrc || img.src;
    galleryModal.classList.add('is-open');
  }

  function closeGalleryModal() {
    if (!galleryModal) return;
    galleryModal.classList.remove('is-open');
  }

function syncSwatchActiveClass(stepEl) {
  if (!stepEl) return;
  const idx = stepElements.indexOf(stepEl);
  const state = idx >= 0 ? stepsState[idx] : null;
  const allInputs = Array.from(stepEl.querySelectorAll('.cp-swatch__input'));
  if (state && allInputs.length) {
    const anyChecked = stepEl.querySelector('.cp-swatch__input:checked');
    if (!anyChecked && state.color) {
      const fallback = allInputs.find((i) => i.value === state.color);
      if (fallback) fallback.checked = true;
    }
  }
  const labels = stepEl.querySelectorAll('.cp-swatch');
  labels.forEach((label) => {
    const input = label.querySelector('.cp-swatch__input');
    const dot = label.querySelector('.cp-swatch__dot');
    if (!dot || !input) return;

    if (input.checked) {
      dot.classList.add('cp-swatch__dot--active');
    } else {
      dot.classList.remove('cp-swatch__dot--active');
    }
  });
}

  function updateStepUI() {
    stepElements.forEach((stepEl, idx) => {
      stepEl.hidden = idx !== currentStep;
    });

    if (currentStepLabel) currentStepLabel.textContent = String(currentStep + 1);

    if (btnPrev) btnPrev.disabled = currentStep === 0;

    const isLast = currentStep === totalSteps - 1;
    if (btnNext) {
      btnNext.hidden = isLast;
      if (!isLast) btnNext.textContent = 'Próximo item';
    }

    const allSelected = stepsState.every((s) => !!s.selectedVariant);
    const colorHasStock = (stepIdx) => {
      const s = stepsState[stepIdx];
      if (!s) return false;
      const c = s.color || '';
      return s.variants.some((v) => v.option1 === c && !!v.available);
    };
    const allColorsHaveStock = stepsState.every((_, i) => colorHasStock(i));
    if (btnSubmit) {
      btnSubmit.hidden = !isLast;
      btnSubmit.disabled = !(allSelected && allColorsHaveStock);
    }

    const currState = stepsState[currentStep];
    const canGoNext = !!currState.selectedVariant;
    const currColorHasStock = colorHasStock(currentStep);
    if (btnNext) btnNext.disabled = (currentStep < totalSteps - 1) && (!canGoNext || !currColorHasStock);

    syncGalleryWithStep();
  }

  function updateSizeAvailabilityForStep(stepIdx) {
    const stepEl = stepElements[stepIdx];
    if (!stepEl) return;
    const state = stepsState[stepIdx];
    const colorValue = state.color || '';
    const sizes = Array.from(stepEl.querySelectorAll('.conjunto-option__input--size'));
    const labels = Array.from(stepEl.querySelectorAll('.conjunto-option--size'));

    let mustClearSelection = false;

    sizes.forEach((inp) => {
      const val = inp.value;
      const hasAvailable = state.variants.some(
        (v) => v.option1 === colorValue && v.option2 === val && v.available
      );
      const label = labels.find((l) => l.contains(inp));

      if (!hasAvailable) {
        inp.disabled = true;
        if (label) {
          label.classList.add('size-swatch--sold-out');
          const span = label.querySelector('.size-swatch__label');
          if (span) span.classList.add('size-swatch__label--sold-out');
        }
        if (inp.checked) {
          mustClearSelection = true;
        }
      } else {
        inp.disabled = false;
        if (label) {
          label.classList.remove('size-swatch--sold-out');
          const span = label.querySelector('.size-swatch__label');
          if (span) span.classList.remove('size-swatch__label--sold-out');
        }
      }
    });

    // Se o tamanho que estava selecionado ficou inválido, só limpa (sem toast aqui)
    if (mustClearSelection) {
      sizes.forEach((inp) => { inp.checked = false; });
      state.size = '';
      state.selectedVariant = null;
    }
  }

function updateSelectionForStep(stepIdx, evt, propagate = true) {
  const isUserAction = !!(evt && evt.isTrusted);
  const stepEl = stepElements[stepIdx];
  if (!stepEl) return;
  const state = stepsState[stepIdx];
  if (!state) return;

  const variantInput = stepEl.querySelector('[data-conjunto-variant-id]');

  const checkedColor = stepEl.querySelector('.conjunto-option__input--color:checked');
  const checkedSize = stepEl.querySelector('.conjunto-option__input--size:checked');

  const colorValue = checkedColor ? checkedColor.value : state.color || '';
  const sizeValue = checkedSize ? checkedSize.value : state.size || '';

  state.color = colorValue;
  state.size = sizeValue;

  const variant = getVariantForSelection(stepIdx, colorValue, sizeValue);

  if (!variant) {
    state.selectedVariant = null;

    if (
      isUserAction &&
      evt &&
      evt.target &&
      evt.target.classList &&
      evt.target.classList.contains('conjunto-option__input--size') &&
      typeof window !== 'undefined' &&
      typeof window.showToast === 'function'
    ) {
      window.showToast(
        'Este tamanho está indisponível para esta cor. Escolha outro tamanho.',
        {
          type: 'warning',
          duration: 4000
        }
      );
    }
  } else {
    state.selectedVariant = variant;

    if (variantInput) {
      variantInput.value = variant.id;
    }

    try {
      const url = new URL(window.location.href);
      url.searchParams.set(`conjunto_variant_${stepIdx}`, String(variant.id));
      url.searchParams.set('variant', String(variant.id));
      history.replaceState(null, '', url.toString());
    } catch (_) { }

    try {
      let thumbImg = stepEl.querySelector('.conjunto-step__thumb');
      let nextSrc = '';

      if (variant?.featured_image?.src) {
        nextSrc = variant.featured_image.src;
      }

      if (!nextSrc && variant?.featured_media?.preview_image?.src) {
        nextSrc = variant.featured_media.preview_image.src;
      }

      if (!nextSrc) {
        const items = itemsForStep(stepIdx);
        const colorKey = norm(state.color || '');
        const firstItem = items.find((it) => itemMatchesColor(it, colorKey));
        const imgEl = firstItem ? firstItem.querySelector('img') : null;
        if (imgEl) nextSrc = imgEl.currentSrc || imgEl.src;
      }

      if (!thumbImg) {
        const wrapper = stepEl.querySelector('.conjunto-step__thumb-wrapper');
        if (wrapper) {
          const created = document.createElement('img');
          created.className = 'conjunto-step__thumb';
          wrapper.innerHTML = '';
          wrapper.appendChild(created);
          thumbImg = created;
        }
      }
      if (thumbImg && nextSrc) {
        try { thumbImg.removeAttribute('srcset'); } catch (_) { }
        try { thumbImg.removeAttribute('sizes'); } catch (_) { }
        try { thumbImg.setAttribute('loading', 'eager'); } catch (_) { }
        thumbImg.src = nextSrc;
      }
    } catch (_) { }
  }

  syncSwatchActiveClass(stepEl);

  recalcTotals();
  updateStepUI();
  updateSizeAvailabilityForStep(stepIdx);

  if (propagate) {
    const fromState = stepsState[stepIdx];
    for (let j = stepIdx + 1; j < stepsState.length; j++) {
      applyColorSizeFromStateToStep(fromState, j);
    }
  }
}

function attachStepListeners() {
  stepElements.forEach((stepEl, idx) => {
    const colorInputs = Array.from(stepEl.querySelectorAll('.conjunto-option__input--color'));
    const sizeInputs = Array.from(stepEl.querySelectorAll('.conjunto-option__input--size'));
    function updateSelection(evt) {
      updateSelectionForStep(idx, evt, true);
    }

    colorInputs.forEach((input) => {
      input.addEventListener('change', updateSelection);
    });

    sizeInputs.forEach((input) => {
      input.addEventListener('change', updateSelection);
    });
  });
}

  function initFromUrlVariantsOrDefault() {
    stepElements.forEach((stepEl, idx) => {
      const colorInputs = Array.from(stepEl.querySelectorAll('.conjunto-option__input--color'));
      const sizeInputs = Array.from(stepEl.querySelectorAll('.conjunto-option__input--size'));
      const variantInput = stepEl.querySelector('[data-conjunto-variant-id]');
      const variants = stepsState[idx]?.variants || [];
      let applied = false;
      try {
        const url = new URL(window.location.href);
        const vid = url.searchParams.get(`conjunto_variant_${idx}`) || '';
        if (vid) {
          const v = variants.find((x) => String(x.id) === String(vid));
          if (v) {
            const colorEl = colorInputs.find((i) => String(i.value) === String(v.option1));
            if (colorEl) colorEl.checked = true;
            const sizeEl = sizeInputs.find((i) => String(i.value) === String(v.option2));
            if (sizeEl) sizeEl.checked = true;
            if (variantInput) variantInput.value = String(v.id);
            stepsState[idx].color = v.option1 || '';
            stepsState[idx].size = v.option2 || '';
            stepsState[idx].selectedVariant = v;
            applied = true;
          }
        }
      } catch (_) { }
      if (applied) {
        updateSelectionForStep(idx, null, false);
      }
      syncSwatchActiveClass(stepEl);
    });
  }

  function autoSelectFirstAvailableColors() {
    stepElements.forEach((stepEl) => {
      syncSwatchActiveClass(stepEl);
    });
  }

  // Lê cor/tamanho diretamente do DOM para garantir estado fiel
  function readStateFromDom(stepIdx) {
    const stepEl = stepElements[stepIdx];
    if (!stepEl) return;
    const state = stepsState[stepIdx];
    if (!state) return;

    const checkedColor = stepEl.querySelector('.conjunto-option__input--color:checked');
    const checkedSize = stepEl.querySelector('.conjunto-option__input--size:checked');

    state.color = checkedColor ? checkedColor.value : state.color || '';
    state.size = checkedSize ? checkedSize.value : state.size || '';

    const variant = getVariantForSelection(stepIdx, state.color, state.size);
    state.selectedVariant = variant || null;
  }

  /**
   * Aplica cor/tamanho de um state de origem em um step de destino
   * (usado no botão Próximo e na propagação inicial)
   */
  function applyColorSizeFromStateToStep(fromState, toIdx) {
    const toStepEl = stepElements[toIdx];
    if (!fromState || !toStepEl) return;

    // Cor
    if (fromState.color) {
      const colorInputsNext = Array.from(
        toStepEl.querySelectorAll('.conjunto-option__input--color')
      );
      const targetColorInput =
        colorInputsNext.find(i => i.value === fromState.color && !i.disabled) ||
        colorInputsNext.find(i => i.value === fromState.color) ||
        colorInputsNext[0];

      if (targetColorInput) {
        if (!targetColorInput.checked) {
          targetColorInput.checked = true;
        }
      }
    }

    // Tamanho
    if (fromState.size) {
      const sizeInputsNext = Array.from(
        toStepEl.querySelectorAll('.conjunto-option__input--size')
      );
      const targetSizeInput =
        sizeInputsNext.find(i => i.value === fromState.size && !i.disabled) ||
        sizeInputsNext.find(i => i.value === fromState.size) ||
        sizeInputsNext[0];

      if (targetSizeInput) {
        if (!targetSizeInput.checked) {
          targetSizeInput.checked = true;
        }
      }
    }

    updateSelectionForStep(toIdx, null, false);
  }

  /**
   * Propaga cor/tamanho do primeiro step para TODOS os outros
   * logo que a página carrega (pra soma já nascer certa, inclusive por tamanho)
   */
  function propagateInitialFromFirstStep() {
    readStateFromDom(0);
    const firstState = stepsState[0];
    if (!firstState) return;

    for (let i = 1; i < stepsState.length; i++) {
      applyColorSizeFromStateToStep(firstState, i);
    }

    recalcTotals();
    updateStepUI();
  }

  if (btnPrev) {
    btnPrev.addEventListener('click', () => {
      if (currentStep > 0) {
        currentStep -= 1;
        updateStepUI();
      }
    });
  }

  // Propagar cor e tamanho para o PRÓXIMO step (navegação)
  if (btnNext) {
    btnNext.addEventListener('click', () => {
      if (currentStep < totalSteps - 1) {
        const fromIdx = currentStep;
        const fromState = stepsState[fromIdx];
        const toIdx = fromIdx + 1;

        // Se ainda não tiver variante selecionada, avisa o usuário
        if (!fromState || !fromState.selectedVariant) {
          if (typeof window !== 'undefined' && typeof window.showToast === 'function') {
            window.showToast('Selecione cor e tamanho deste item antes de avançar.', {
              type: 'warning',
              duration: 3500
            });
          }
          return;
        }

        currentStep = toIdx;
        applyColorSizeFromStateToStep(fromState, toIdx);
        updateStepUI();
      }
    });
  }

  if (btnSubmit) {
    btnSubmit.addEventListener('click', async (event) => {
      // Se o botão estiver desabilitado, não tenta enviar, só avisa o motivo
      if (btnSubmit.disabled) {
        if (typeof window !== 'undefined' && typeof window.showToast === 'function') {
          window.showToast(
            'Selecione cor e tamanho para todos os itens do conjunto antes de adicionar ao carrinho.',
            {
              type: 'warning',
              duration: 4000
            }
          );
        }
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      const allSelected = stepsState.every((s) => !!s.selectedVariant);

      if (!allSelected) {
        if (typeof window !== 'undefined' && typeof window.showToast === 'function') {
          window.showToast('Você precisa selecionar cor e tamanho para todos os itens do conjunto.', {
            type: 'warning',
            duration: 4000
          });
        }
        return;
      }

      // ======================================================
      // ORIGEM: liberação NO MESMO PADRÃO do main-kit.js
      // (markAtc + flush + micro-yield) ANTES de /cart/update.js
      // e ANTES de /cart/add.js
      // ======================================================
      await originReleaseBeforeCartOps(btnSubmit);

      const codeEarly = (couponName || '').trim();
      if (codeEarly) {
        (async () => {
          const tryApply = async () => {
            const el = document.querySelector('#cart-drawer-root cart-discount') || document.querySelector('cart-discount');
            const input = el?.querySelector('.cart-discount__input');
            if (el && input) {
              input.value = codeEarly;
              if (typeof el.applyDiscount === 'function') {
                try { await el.applyDiscount({ preventDefault: function () { }, stopPropagation: function () { } }); } catch (_) { }
                return true;
              }
            }
            return false;
          };
          let applied = false;
          for (let i = 0; i < 40; i++) {
            applied = await tryApply();
            if (applied) break;
            await new Promise((r) => setTimeout(r, 100));
          }
          if (!applied) {
            try {
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: new URLSearchParams({
                  discount: codeEarly,
                  'attributes[discount_code]': codeEarly
                })
              });
            } catch (_) { }
          }
          try { document.querySelectorAll('.cart-discount__input').forEach((i) => { i.value = ''; }); } catch (_) { }
        })();
      }

      const items = stepsState.map((s) => {
        const stepEl = stepElements[s.stepIndex];
        const itemHandle = stepEl ? stepEl.dataset.conjuntoItemHandle : '';
        const isGift = stepEl ? stepEl.classList.contains('conjunto-step--gift') : false;

        return {
          id: s.selectedVariant.id,
          quantity: 1,
          properties: {
            '_conjunto_parent': conjuntoMeta.parent_handle || '',
            '_conjunto_item': itemHandle || '',
            '_is_conjunto_gift': isGift ? 'true' : 'false'
          }
        };
      });

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });

        // 🔹 MELHORIA: recarrega o drawer ANTES de abrir, pra já vir atualizado
        if (window.CART_DRAWER) {
          try {
            if (typeof window.CART_DRAWER.reload === 'function') {
              await window.CART_DRAWER.reload();
            }
          } catch (_) { }
          try {
            if (typeof window.CART_DRAWER.open === 'function') {
              window.CART_DRAWER.open();
            }
          } catch (_) { }
        }

        try {
          const el = document.querySelector('#cart-drawer-root cart-discount') || document.querySelector('cart-discount');
          if (el && typeof el.updateCartElementsOptimized === 'function') {
            await el.updateCartElementsOptimized();
          }
          if (window.CART_DRAWER && typeof window.CART_DRAWER.refreshDiscounts === 'function') {
            window.CART_DRAWER.refreshDiscounts();
          }
          try { document.querySelectorAll('.cart-discount__input').forEach((i) => { i.value = ''; }); } catch (_) { }
          try {
            const el2 = document.querySelector('#cart-drawer-root cart-discount') || document.querySelector('cart-discount');
            if (el2) {
              setTimeout(async function () {
                try {
                  const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
                  const cart = res.ok ? await res.json() : null;
                  if (cart && typeof el2.updateDiscountsOnly === 'function') {
                    el2.updateDiscountsOnly(cart);
                  }
                } catch (_) { }
              }, 60);
            }
          } catch (_) { }
        } catch (_) { }

        // Sucesso ao adicionar o conjunto
        if (typeof window !== 'undefined' && typeof window.showToast === 'function') {
          window.showToast('Conjunto adicionado ao carrinho com sucesso!', {
            type: 'success',
            duration: 3500
          });
        }
      } catch (err) {
        console.error('Erro ao adicionar conjunto ao carrinho', err);
        if (typeof window !== 'undefined' && typeof window.showToast === 'function') {
          window.showToast('Não foi possível adicionar o conjunto ao carrinho. Tente novamente.', {
            type: 'error',
            duration: 5000
          });
        }
      }
    });
  }

  if (galleryPrev) {
    galleryPrev.addEventListener('click', () => {
      goGallery(-1);
    });
  }

  if (galleryNext) {
    galleryNext.addEventListener('click', () => {
      goGallery(1);
    });
  }

  if (galleryTrack) {
    galleryTrack.addEventListener('click', (e) => {
      const target = e.target;
      if (target.matches('.conjunto-gallery__image')) {
        openGalleryModalFromActive();
      }
    });
  }

  if (galleryModalClose) {
    galleryModalClose.addEventListener('click', closeGalleryModal);
  }
  if (galleryModalBackdrop) {
    galleryModalBackdrop.addEventListener('click', closeGalleryModal);
  }

attachStepListeners();
initFromUrlVariantsOrDefault();
propagateInitialFromFirstStep();
recalcTotals();
updateStepUI();
stepElements.forEach((_, idx) => updateSizeAvailabilityForStep(idx));
stepElements.forEach((stepEl) => {
  syncSwatchActiveClass(stepEl);
});
})();
